// dprint-ignore-file

/**
 * Constants
 */

// Array pool constants
export const MAX_ARENA_SIZE: i32 = 25165824 // 128MB (32M floats)

// Sequencer constants
export const MAX_PITCHES: i32 = 16 // Max polyphony per sequence
export const MAX_NOTES: i32 = 128 // Max notes per sequence

// Executor constants
export const MAX_STACK_SIZE: i32 = 64
export const MAX_VARS: i32 = 4096
export const MAX_BYTECODE_SIZE: i32 = 4096
export const MAX_DSP_ID: i32 = 4096 // Max DSP block ID (for array-based storage instead of Maps)
export const DSP_RESET_DIFF_THRESHOLD: i32 = 100 // Reset DSP blocks if diff count exceeds this

// Object pool constants
export const MAX_PARTIALS: i32 = 64 // Max partials for HARMONICS

// Sample constants
export const MAX_SAMPLE_TIME: f32 = 15.0 // seconds
export const SAMPLE_RATE: f32 = 48000.0
export const MAX_SAMPLE_LENGTH: i32 = MAX_SAMPLE_TIME * SAMPLE_RATE as i32 // 720000 samples
export const MAX_SAMPLES: i32 = 4 // Fixed number of sample buffers

// Waveform visualization constants
export const MAX_WAVEFORMS: i32 = 16 // Maximum number of waveform() calls
export const WAVEFORM_BUFFER_SIZE: i32 = 16384 // Samples per waveform buffer for visualization

// Pool sizes
export const POOL_SIZE_STATIC_INT32_ARRAY: i32 = 64
export const POOL_SIZE_NOTE_DATA: i32 = MAX_NOTES * 4 // Enough for a few sequences
export const POOL_SIZE_SEQUENCE_DATA: i32 = 16
export const POOL_SIZE_SEQUENCER_STATE: i32 = 32
export const POOL_SIZE_SWAP_STATE: i32 = 32
export const POOL_SIZE_STATIC_FLOAT32_ARRAY_ARRAY: i32 = 8
export const POOL_SIZE_SMALL_STATIC_INT32_ARRAY: i32 = 16
